// icons
import calendarIcon from '@iconify/icons-carbon/calendar';
import hourglassIcon from '@iconify/icons-carbon/hourglass';
import locationIcon from '@iconify/icons-carbon/location';
// @mui
import { Card, Stack, Typography } from '@mui/material';
// @types
import { JobProps } from 'src/@types/job';
// components
import { Iconify, TextIconLabel } from 'src/components';
import { fDate } from 'src/utils/formatTime';

// ----------------------------------------------------------------------

type Props = {
  job: JobProps;
};

export default function JobInfo({ job }: Props) {
  const { posted_date, expiration_date } = job;

  return (
    <Card sx={{ p: 3 }}>
      <Stack spacing={2}>
        <TextIconLabel
          spacing={2}
          alignItems="flex-start"
          icon={<Iconify icon={calendarIcon} sx={{ width: 24, height: 24 }} />}
          value={
            <Stack>
              <Typography variant="subtitle2"> Dato publisert </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {fDate(posted_date)}
              </Typography>
            </Stack>
          }
        />

        <TextIconLabel
          spacing={2}
          alignItems="flex-start"
          icon={<Iconify icon={hourglassIcon} sx={{ width: 24, height: 24 }} />}
          value={
            <Stack>
              <Typography variant="subtitle2"> Dato utgår </Typography>
              <Typography variant="body2" sx={{ color: 'error.main' }}>
                {expiration_date ? fDate(expiration_date) : "Ansetter fortløpende"}
              </Typography>
            </Stack>
          }
        />

        <TextIconLabel
          spacing={2}
          alignItems="flex-start"
          icon={<Iconify icon={locationIcon} sx={{ width: 24, height: 24 }} />}
          value={
            <Stack>
              <Typography variant="subtitle2"> Sted </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                Bergen, Vestland
              </Typography>
            </Stack>
          }
        />


      </Stack>
    </Card>
  );
}
